<crm-sidenav-form-container
  title="{{ title | i18nextCap }}"
  [isDeletable]="isDeletable"
  [formGroup]="form"
  [formFields]="formFields"
  (onSubmit)="onCreate()"
  (onCancel)="onClose()"
  (onDelete)="onDelete()"
></crm-sidenav-form-container>
